var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBgCoupon02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 295 110"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "bg_coupon02_svg__a",
  width: 295,
  height: 110,
  x: 0,
  y: 0,
  fill: "#000",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h295v110H0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M246.326 1c0 3.254-2.668 5.891-5.959 5.891-3.292 0-5.96-2.637-5.96-5.89V1H1v108h233.407c0-3.253 2.668-5.891 5.96-5.891s5.959 2.638 5.959 5.891H294V1z",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M246.326 1c0 3.254-2.668 5.891-5.959 5.891-3.292 0-5.96-2.637-5.96-5.89V1H1v108h233.407c0-3.253 2.668-5.891 5.96-5.891s5.959 2.638 5.959 5.891H294V1z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.1,
  d: "M234.407 1h1V0h-1zM1 1V0H0v1zm0 108H0v1h1zm233.407 0v1h1v-1zm11.919 0h-1v1h1zM294 109v1h1v-1zm0-108h1V0h-1zm-47.674 0V0h-1v1zm-5.959 6.891c3.832 0 6.959-3.074 6.959-6.89h-2c0 2.69-2.21 4.89-4.959 4.89zm-6.96-6.89c0 3.816 3.127 6.89 6.96 6.89v-2c-2.75 0-4.96-2.2-4.96-4.89zm0-.001h2zM1 2h233.407V0H1zm1 107V1H0v108zm232.407-1H1v2h233.407zm1 1c0-2.69 2.21-4.891 4.96-4.891v-2c-3.833 0-6.96 3.074-6.96 6.891zm4.96-4.891c2.749 0 4.959 2.201 4.959 4.891h2c0-3.817-3.127-6.891-6.959-6.891zM294 108h-47.674v2H294zM293 1v108h2V1zm-46.674 1H294V0h-47.674zm1-1h-2z",
  mask: "url(#bg_coupon02_svg__a)"
})));
export default SvgBgCoupon02;